module.exports = __webpack_public_path__ + "img/server-06.680eb8f7.svg";